// frontend/src/services/adminApi.ts
import axiosInstance from '../api/axiosInstance'; // Assuming axiosInstance is configured for authentication

const ADMIN_BASE_URL = '/admin'; // axiosInstance already has baseURL: '/api'

export const adminApi = {
  // Dashboard Statistics
  getDashboardStats: async () => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/dashboard/stats/`);
    return response.data;
  },

  // User Management
  getUsers: async (params?: any) => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/users/`, { params });
    return response.data;
  },
  getUser: async (id: number) => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/users/${id}/`);
    return response.data;
  },
  createUser: async (userData: any) => {
    const response = await axiosInstance.post(`${ADMIN_BASE_URL}/users/`, userData);
    return response.data;
  },
  updateUser: async (id: number, userData: any) => {
    const response = await axiosInstance.put(`${ADMIN_BASE_URL}/users/${id}/`, userData);
    return response.data;
  },
  partialUpdateUser: async (id: number, userData: any) => {
    const response = await axiosInstance.patch(`${ADMIN_BASE_URL}/users/${id}/`, userData);
    return response.data;
  },
  deleteUser: async (id: number) => {
    const response = await axiosInstance.delete(`${ADMIN_BASE_URL}/users/${id}/`);
    return response.data;
  },
  resetUserPassword: async (id: number, data: { password: string }) => {
    const response = await axiosInstance.post(
      `${ADMIN_BASE_URL}/users/${id}/reset_password/`,
      data
    );
    return response.data;
  },
  getUserConversations: async (id: number, params?: any) => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/users/${id}/conversations/`, {
      params,
    });
    return response.data;
  },

  // Conversation Review
  getConversations: async (params?: any) => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/conversations/`, { params });
    return response.data;
  },
  getConversationMessages: async (id: number, params?: any) => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/conversations/${id}/messages/`, {
      params,
    });
    return response.data;
  },

  // Suggested Questions Management
  getSuggestedQuestions: async () => {
    const response = await axiosInstance.get(`${ADMIN_BASE_URL}/suggested_questions/`);
    return response.data;
  },
  createSuggestedQuestion: async (questionData: any) => {
    const response = await axiosInstance.post(
      `${ADMIN_BASE_URL}/suggested_questions/`,
      questionData
    );
    return response.data;
  },
  updateSuggestedQuestion: async (id: number, questionData: any) => {
    const response = await axiosInstance.put(
      `${ADMIN_BASE_URL}/suggested_questions/${id}/`,
      questionData
    );
    return response.data;
  },
  partialUpdateSuggestedQuestion: async (id: number, questionData: any) => {
    const response = await axiosInstance.patch(
      `${ADMIN_BASE_URL}/suggested_questions/${id}/`,
      questionData
    );
    return response.data;
  },
  deleteSuggestedQuestion: async (id: number) => {
    const response = await axiosInstance.delete(`${ADMIN_BASE_URL}/suggested_questions/${id}/`);
    return response.data;
  },
  reorderSuggestedQuestions: async (orderData: { id: number; order: number }[]) => {
    const response = await axiosInstance.post(
      `${ADMIN_BASE_URL}/suggested_questions/reorder/`,
      orderData
    );
    return response.data;
  },
};
